import Vue from 'vue';

// Bootstrap
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'

import App from './App.vue';
import router from './router';
import store from './store';
import config from "./config";
import urls from './urls/config';
import './globals/config';

// plugins init
import './plugins/vue-axios'
import './plugins/vue-lang'
import './plugins/vue-moment'
import './plugins/vue-select'
import './plugins/vue-slider'
import './plugins/vue-snotify'
import './plugins/vuelidate'
import './plugins/vue-time-picker'
import './plugins/vue-scrollto'
import './plugins/vue-ckeditor'
import './plugins/vue-pace'
import './plugins/vue-swal'
import './plugins/vue-apex-chart'

// config init
Vue.prototype.$config = config;
Vue.prototype.$config.urls = urls;
Vue.config.productionTip = false;


new Vue( {
    router,
    store,
    render: h => h( App ),
} ).$mount( '#app' );
